// extracted by css-extract-rspack-plugin
var _1 = "Byff5Y10kF3QcdX1-oWsBw--";
var _2 = "_37AKzUoZTTs3qxN2HbfoTA--";
var _3 = "c7kxZjRHoA-MNMJwsYtvoQ--";
var _4 = "WX-7jJ1HErwKIAy530OX8Q--";
export { _1 as "hideBullets", _2 as "removeListStyle", _3 as "ul", _4 as "useVariableMarginBottom" }
